import { useEffect, useRef, useState } from "react";
import { setStudioView } from "./studio-views";

export interface GenerationConfirmationProps {
  title: string; action: string; quoteId: string; credits: number | string;
  images: number | string | null | undefined; regeneration?: number | string;
  message: string; confirm: () => Promise<void>; refresh: () => void; close: () => void;
}
export function GenerationConfirmation(p: GenerationConfirmationProps) {
  const dialog = useRef<HTMLDialogElement>(null), pending = useRef(false);
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  useEffect(() => {
    const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialog.current?.showModal();
    return () => { if (opener?.isConnected) opener.focus(); };
  }, []);
  const confirm = async () => {
    if (pending.current || p.images == null) return;
    pending.current = true; setBusy(true);
    try { await p.confirm(); }
    catch (reason) { setError(reason instanceof Error ? reason.message : String(reason)); }
    finally { pending.current = false; setBusy(false); }
  };
  return <dialog ref={dialog} aria-labelledby="generationConfirmationTitle" onCancel={event => { if (pending.current) event.preventDefault(); else p.close(); }}>
    <div className="dialog-head"><h2 id="generationConfirmationTitle">{p.title}</h2><button className="close" aria-label="Close generation confirmation" disabled={busy} onClick={p.close}>x</button></div>
    <div className="dialog-body"><div className="quote-card"><div className="eyebrow">Live server quote</div><div className="quote-total">{p.credits} credits</div><div className="quote-list">
      <div><span>Images / outputs</span><b>{p.images ?? "Not reported - generation blocked"}</b></div><div><span>Action</span><b>{p.action.replaceAll("_", " ")}</b></div><div><span>Quote ID</span><b>{p.quoteId}</b></div>
      {p.regeneration != null && <div><span>Regeneration costs</span><b>{p.regeneration} credits</b></div>}
    </div><p className="subtle">{p.message}</p></div><div className="notice warn">Credits are consumed only after you press <b>Confirm &amp; generate</b>. Closing this dialog keeps the saved draft and uses no generation credits.</div>
      {error && <div className="notice warn" role="alert"><b>Generation stopped without an output.</b><p>{error}</p>Request a fresh quote before trying again.</div>}
    </div><div className="dialog-foot"><button className="btn ghost" disabled={busy} onClick={p.close}>Cancel</button><button className="btn primary" disabled={busy || p.images == null} onClick={error ? p.refresh : () => { void confirm(); }}>{busy ? "Starting generation..." : error ? "Request fresh quote" : "Confirm & generate"}</button></div>
  </dialog>;
}
export function showGenerationConfirmation(props: GenerationConfirmationProps) {
  setStudioView("confirmation", props.quoteId, <GenerationConfirmation {...props} />);
}
